import React from 'react'; 

function BadgesUsadas(props){

    return(  
        props.badges.length !== 0?
            props.badges.map(function(elem){
                return(  
                    <p className='badgeSelects my-1 me-2'>
                        <div className='centrarContainer containerBadge'>
                            <div className='textoBadge'>{elem.label}</div>
                            <div className="ms-1 cruzBadge"alt=""  onClick={()=>props.funcion(elem)}/>

                        </div>
                    </p>
                )
            })
        :
            <></>
            
    );
}


export default BadgesUsadas;